import React from "react";
import { useMediaQuery } from "react-responsive";
import SuccesStoryCheckoutCode from "@components/success-story-checkoutcod";
export const SectionFour = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div className="section-2">
      <div className="container-fluid">
        <div className="top-text mb-5">
          <h1>Powering Ecommerce Everywhere</h1>
          <p>
            Seamless checkout, higher conversions, low RTO—no matter the
            platform
          </p>
        </div>

        <div
          className="h-auto md:h-[420px]"
          style={{ marginTop: "150px", marginBottom: "150px" }}
        >
          <div className="central-image d-none d-lg-block">
            <img
              src="/assets/images/kwikcheckoutcod/secbtn.png"
              alt="KwikPass with Arrows"
              style={{ height: "440px", width: "auto" }}
            />
          </div>

          <div className="feature-box top1 d-none d-lg-block">
            <div className="icon-container">
              <img
                src="/assets/images/kwikcheckoutcod/shopify.png"
                alt="Shopify"
                className="icon"
              />
            </div>
            <h4>Shopify</h4>
          </div>

          <div className="feature-box top-right1 d-none d-lg-block">
            <div className="icon-container">
              <img
                src="/assets/images/kwikcheckoutcod/woocomm.png"
                alt="Custom Store"
                className="icon"
              />
            </div>
            <h4>Woocommerce</h4>
          </div>

          <div className="feature-box left1 d-none d-lg-block">
            <div className="icon-container">
              <img
                src="/assets/images/kwikcheckoutcod/reactnative.png"
                alt="Custom Store"
                className="icon"
              />
            </div>
            <h4>React Native</h4>
          </div>

          <div className="feature-box right1 d-none d-lg-block">
            <div className="icon-container">
              <img
                src="/assets/images/kwikcheckoutcod/salesforce.png"
                alt="Custom Store"
                className="icon"
              />
            </div>
            <h4>SFCC</h4>
          </div>

          <div className="feature-box bottom1 d-none d-lg-block">
            <div className="icon-container">
              <img
                src="/assets/images/kwikcheckoutcod/java.png"
                alt="Custom Store"
                className="icon"
              />
            </div>
            <h4>Java</h4>
          </div>

          <div className="feature-box bottom-right1 d-none d-lg-block">
            <div className="icon-container">
              <img
                src="/assets/images/kwikcheckoutcod/php.png"
                alt="App"
                className="icon"
              />
            </div>
            <h4>Php</h4>
          </div>

          <div className="feature-box bottom-left1 d-none d-lg-block">
            <div className="icon-container">
              <img
                src="/assets/images/kwikcheckoutcod/react.png"
                alt="Website"
                className="icon"
              />
            </div>
            <h4>React</h4>
          </div>

          <div className="feature-box top-left1 d-none d-lg-block">
            <div className="icon-container">
              <img
                src="/assets/images/kwikcheckoutcod/magento.png"
                alt="Mobile"
                className="icon"
              />
            </div>
            <h4>Magento</h4>
          </div>
        </div>

        <div className="row feature-row1 d-lg-none">
          <div className="col-12 col-md-6">
            <div className="feature-box">
              <div className="icon-container">
                <img
                  src="/assets/images/kwikcheckoutcod/shopify.png"
                  alt="Shopify"
                  className="icon"
                />
              </div>
              <h4>Shopify</h4>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="feature-box">
              <div className="icon-container">
                <img
                  src="/assets/images/kwikcheckoutcod/woocomm.png"
                  alt="Shopify"
                  className="icon"
                />
              </div>
              <h4>Woocommerce</h4>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="feature-box">
              <div className="icon-container">
                <img
                  src="/assets/images/kwikcheckoutcod/java.png"
                  alt="Shopify"
                  className="icon"
                />
              </div>
              <h4>Java</h4>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="feature-box">
              <div className="icon-container">
                <img
                  src="/assets/images/kwikcheckoutcod/react.png"
                  alt="Shopify"
                  className="icon"
                />
              </div>
              <h4>React</h4>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="feature-box">
              <div className="icon-container">
                <img
                  src="/assets/images/kwikcheckoutcod/reactnative.png"
                  alt="Shopify"
                  className="icon"
                />
              </div>
              <h4>React Native</h4>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="feature-box">
              <div className="icon-container">
                <img
                  src="/assets/images/kwikcheckoutcod/salesforce.png"
                  alt="Shopify"
                  className="icon"
                />
              </div>
              <h4>SFCC</h4>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="feature-box">
              <div className="icon-container">
                <img
                  src="/assets/images/kwikcheckoutcod/php.png"
                  alt="Shopify"
                  className="icon"
                />
              </div>
              <h4>Php</h4>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="feature-box">
              <div className="icon-container">
                <img
                  src="/assets/images/kwikcheckoutcod/magento.png"
                  alt="Shopify"
                  className="icon"
                />
              </div>
              <h4>Magento</h4>
            </div>
          </div>
        </div>

        <div className="top-text mt-5">
          <h1>The GoKwik Network Effect</h1>
          <p>
            Leverage network data capabilities to optimise your ecommerce
            checkout
          </p>
        </div>

        <div className="row d-flex justify-content-center mt-5 mb-5">
          <div className="details">
            <div className="accurate d-flex same">
              <h1>130Mn+</h1>
              {isMobile ? (
                <p>
                  Deepest Pool Of <br /> Verified Shoppers
                </p>
              ) : (
                <p className="mobile">
                  Deepest Pool <br /> Of Verified <br /> Shoppers
                </p>
              )}
            </div>
            <div className="line"></div>
            <div className="d-flex same">
              <h1>85%</h1>
              <p>
                Shopper <br /> Address Pre-Fill Rate
              </p>
            </div>
            <div className="line"></div>
            <div className="active d-flex same">
              <h1>320%</h1>
              <p>
                Repeat <br /> Orders <br /> Increased
              </p>
            </div>

            <div className="line"></div>
            <div className="active d-flex same">
              <h1> {"<"}50ms</h1>
              <p>
                Fastest Funnel <br /> Movement With <br /> Latency
              </p>
            </div>
          </div>
        </div>

        <div className="top-text mb-5">
          <h1>Success Stories</h1>
          <p>What Our Merchants Say: Real Results, Real Growth</p>
        </div>
      </div>

      <SuccesStoryCheckoutCode customClass="" category={[6, 2]} />
    </div>
  );
};
